import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import ApartmentIcon from "@material-ui/icons/Apartment";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import WarningIcon from "@material-ui/icons/Warning";
import HomeIcon from "@material-ui/icons/Home";
import { Link } from "react-router-dom";

import {
  loadAccountList,
  assistanceTotal,
  incidentsPendingDashboard,
  ListarVisitasCliente,
  assistanceTotalCustomers,
  incidentsPendingClient,
  ListarVisitasDashboard,
  incidentsPendingClientDashboard,
} from "../utils/Actions";
import { size } from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 200,
    width: 200,

    display: "column",
    backgroundColor: "red",
  },
  control: {
    padding: theme.spacing(2),
  },
  alignCenter: {
    alignSelf: "center",
  },
  nolink: {
    textDecoration: "none",
    color: "#000",
  },
}));
const initialstate = {
  totalaccounts: 0,
  totalpersonal: 0,
  totalincidentes: 0,
};
export default function Dashboard() {
  const classes = useStyles();
  const [state, setstate] = useState(initialstate);
  const account = localStorage.getItem("Account");
  const accountJSON = JSON.parse(account);
  const { rol, accountAsigned, accountAsignedName } = accountJSON[0];

  useEffect(() => {
    (async () => {
      if (rol !== 4) {
        setstate({
          ...state,
          totalaccounts: size((await loadAccountList()).data),
          totalpersonal: size((await assistanceTotal()).data),
          totalincidentes: size((await incidentsPendingDashboard()).data),
        });
      } else {
        console.log("HOLIS POLIS");
        console.log(await ListarVisitasDashboard(accountAsigned));
        setstate({
          ...state,
          totalaccounts: size(
            (await ListarVisitasDashboard(accountAsigned)).data
          ),
          totalpersonal: size(
            (await assistanceTotalCustomers(accountAsigned)).data
          ),
          totalincidentes: size(
            (await incidentsPendingClientDashboard(accountAsigned)).data
          ),
        });
      }
    })();
  });

  return (
    <Grid container className={classes.root} spacing={2} direction="column">
      {rol !== 4 ? (
        <>
          <Typography
            variant="h5"
            style={{
              marginBottom: 20,
              backgroundColor: "#fff",
              padding: 10,
              borderRadius: 5,
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <HomeIcon />
            Bienvenido al Sistema De Gestión de Seguridad Sayeret
          </Typography>

          <div
            style={{
              alignSelf: "center",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "row",
              marginBottom: 20,
            }}
          >
            <Typography
              variant="h6"
              style={{
                alignSelf: "center",
                backgroundColor: "#fff",
                padding: 10,
                borderRadius: 5,
              }}
              justify="center"
            >
              Estatus Actual Del Negocio
            </Typography>
          </div>
          <Paper className={classes.control} variant="elevation">
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              spacing={10}
              style={{ marginTop: 20 }}
            >
              <Grid item item xs={4}>
                <Link to="/customers" className={classes.nolink}>
                  <Typography
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    <ApartmentIcon
                      style={{ alignSelf: "center", fontSize: 50 }}
                    />
                  </Typography>
                  <Typography
                    variant="h6"
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    Clientes
                  </Typography>
                  <Typography
                    variant="h6"
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    {state.totalaccounts}
                  </Typography>
                </Link>
              </Grid>
              <Grid item xs={4}>
                <Link to="/inSite" className={classes.nolink}>
                  <Typography
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    <AssignmentIndIcon fontSize="large" />
                  </Typography>

                  <Typography
                    variant="h6"
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    Guardias en Turno
                  </Typography>
                  <Typography
                    variant="h6"
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    {state.totalpersonal}
                  </Typography>
                </Link>
              </Grid>
              <Grid item xs={4}>
                <Link to="/incidents" className={classes.nolink}>
                  <Typography
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    <WarningIcon fontSize="large" />
                  </Typography>
                  <Typography
                    Typography
                    variant="h6"
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    Incidentes
                  </Typography>
                  <Typography
                    variant="h6"
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    {state.totalincidentes}
                  </Typography>
                </Link>
              </Grid>
            </Grid>
          </Paper>
        </>
      ) : (
        <>
          <Typography
            variant="h5"
            style={{
              marginBottom: 20,
              backgroundColor: "#fff",
              padding: 10,
              borderRadius: 5,
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <HomeIcon />
            Bienvenido al Sistema Web
          </Typography>

          <div
            style={{
              alignSelf: "center",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "row",
              marginBottom: 20,
            }}
          >
            <Typography
              variant="h6"
              style={{
                alignSelf: "center",
                backgroundColor: "#fff",
                padding: 10,
                borderRadius: 5,
              }}
              justify="center"
            >
              Estatus Actual De La Cuenta
            </Typography>
          </div>
          <Paper className={classes.control} variant="elevation">
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              spacing={10}
              style={{ marginTop: 20 }}
            >
              <Grid item item xs={4}>
                <Link to="/visits" className={classes.nolink}>
                  <Typography
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    <ApartmentIcon
                      style={{ alignSelf: "center", fontSize: 50 }}
                    />
                  </Typography>
                  <Typography
                    variant="h6"
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    Visitas
                  </Typography>

                  <Typography
                    variant="h6"
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    {state.totalaccounts}
                  </Typography>
                </Link>
              </Grid>
              <Grid item xs={4}>
                <Link to="/insite" className={classes.nolink}>
                  <Typography
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    <AssignmentIndIcon fontSize="large" />
                  </Typography>

                  <Typography
                    variant="h6"
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    Guardias en Turno
                  </Typography>
                  <Typography
                    variant="h6"
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    {state.totalpersonal}
                  </Typography>
                </Link>
              </Grid>
              <Grid item xs={4}>
                <Link to="/incidents" className={classes.nolink}>
                  <Typography
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    <WarningIcon fontSize="large" />
                  </Typography>
                  <Typography
                    Typography
                    variant="h6"
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    Incidentes
                  </Typography>
                  <Typography
                    variant="h6"
                    style={{ alignSelf: "center", textAlign: "center" }}
                  >
                    {state.totalincidentes}
                  </Typography>
                </Link>
              </Grid>
            </Grid>
          </Paper>
        </>
      )}
    </Grid>
  );
}
